import React from 'react'
import PropTypes from 'prop-types'
import { CloseAlt } from '@ticketswap/comets'
import styled from '@emotion/styled'
import {
  useDialog,
  DialogWindow,
  DialogHeader,
  DialogAdornment,
  DialogBody,
  Text,
  space,
} from '@ticketswap/solar'
import useLocalStorage from '~/hooks/useLocalStorage'
import AppStoreBadges from '../AppStoreBadges'
import { createMarkup } from '~/utils'
import AppsNotification from '~/components/AppsNotification'

const StyledText = styled(Text)`
  text-align: center;
`

const StyledAppStoreBadges = styled(AppStoreBadges)`
  margin-top: ${space[16]};
  justify-content: center;
  text-align: center;
`

function AppsDevicesDialog({ t, eventName, userDevices, ...props }) {
  const [impressions, setImpressions] = useLocalStorage('apps_devices_dialog_impressions', 0)

  const { show, hide, getWindowProps } = useDialog({
    onExited: () => {
      return requestAnimationFrame(() => setImpressions(impressions + 1))
    },
  })

  if (parseInt(impressions) > 0) {
    return props.children({ show })
  }

  const devices = Boolean(userDevices?.length)
    ? userDevices
        .map(device => device.name)
        .join(', ')
        .replace(/, ([^,]*)$/, ' & $1')
    : []

  return (
    <>
      {props.children({ show })}
      <DialogWindow {...getWindowProps()}>
        <DialogHeader>
          {t('event-eventtype:appsConnected.dialog.title')}
          <DialogAdornment right>
            <button onClick={hide}>
              <CloseAlt size={24} />
            </button>
          </DialogAdornment>
        </DialogHeader>
        <AppsNotification
          t={t}
          image="/static/images/apps/mobile-screen-full.jpg"
          eventName={eventName}
        />
        <DialogBody>
          <StyledText
            as="p"
            dangerouslySetInnerHTML={createMarkup(
              t(`event-eventtype:appsConnected.dialog.text`, {
                devices,
              })
            )}
          />
          <StyledAppStoreBadges trackingContext="ALERTS_TOGGLE_CONNECTED_DIALOG" />
        </DialogBody>
      </DialogWindow>
    </>
  )
}

AppsDevicesDialog.propTypes = {
  eventName: PropTypes.string,
  userDevices: PropTypes.arrayOf(
    PropTypes.shape({
      deviceType: PropTypes.string,
      name: PropTypes.string,
    })
  ),
}

export default AppsDevicesDialog
